import { Box, Button, Paper, Typography } from "@mui/material";
import type React from "react";

interface ReservationsDisabledProps {
  onEnable: () => void;
  loading: boolean;
}

export const ReservationsDisabled: React.FC<ReservationsDisabledProps> = ({
  onEnable,
  loading,
}) => {
  return (
    <Paper sx={{ padding: "24px", maxWidth: "600px" }}>
      <Typography variant="h6" sx={{ marginBottom: "16px" }}>
        Reservations are disabled
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ marginBottom: "24px" }}
      >
        Users cannot currently reserve vehicles. Enable reservations to allow
        users to book vehicles in advance. You can configure the reservation
        duration, deposit amount, cancellation window, and no-show grace period.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={onEnable}
        disabled={loading}
      >
        Enable Reservations
      </Button>
    </Paper>
  );
};
